
import { updateActiveChatSession } from "../../actions/data/DataAction";
import {
  CommonDataActionConst,
  ChangeMaintenenceStep,
  BroadcastFlowCreationActionConst,
  ChangeBroadcastStepActionConst,
  GetAllActiveChatsActionConst,
  selectedSessionIdActionConsy,
  GetCurrentShiftActionConst,
  ShiftCheckOutHandlerConst,
  SelectedSessionIdActionConst,
  GetAllCompletedChatSessionsActionConst,
  selectedCompletedSessionIdActionConsy,
} from "../../constants/DataActionConst";
const initialState = {
  loader: false,
  allData: [{ name: "musharaf" }],
  allCitiesAndStates: [],
  propertyTypes: [],
  maintenanceCategories: [],

  maintenanceStepCount: 1,

  boradcastStepCount: 1,

  allActiveChatSessions: [],
  selectedSessionId: null,

  allCompletedChatSessions: [],
  selectedCompletedSessionId: null,

  currentShift: null,

  sessionIdPastShift: null,
};
export default (state = initialState, action) => {
  switch (action.type) {
    //Cities And States

    case CommonDataActionConst.GET_COMMON_MASTER_DATA_REQ:
      state = {
        ...state,
        loader: true,
      };
      break;

    case CommonDataActionConst.GET_COMMON_MASTER_DATA_SUCCESS:
      state = {
        ...state,
        loader: false,
        allCitiesAndStates: action.result.citiesAndStates,
        propertyTypes: action.result.propertyTypes,
        maintenanceCategories: action.result.maintenanceCategories,
      };
      break;

    case CommonDataActionConst.GET_COMMON_MASTER_DATA_FAIL:
      state = {
        ...state,
        loader: false,
      };
      break;

    case ChangeMaintenenceStep.CHANGE_MAINTENANCE_STEP:
      state = {
        ...state,
        maintenanceStepCount: action.step,
      };
      break;

    case ChangeBroadcastStepActionConst.CHANGE_BROADCAST_STEP:
      state = {
        ...state,
        boradcastStepCount: action.step,
      };
      break;

    case GetAllActiveChatsActionConst.GET_ALL_ACTIVE_CHAT_SUCC:
      let selectedId = action?.data[0]?._id ? action?.data[0]?._id : null;
      state = {
        ...state,
        allActiveChatSessions: action.data,
      };
      break;

    case GetAllActiveChatsActionConst.GET_ALL_ACTIVE_CHAT_FAIL:
      state = {
        ...state,
        allActiveChatSessions: [],
        selectedSessionId: null,
      };
      break;

    case GetAllCompletedChatSessionsActionConst.GET_ALL_COMPLETED_CHAT_SUCC:
      state = {
        ...state,
        allCompletedChatSessions: action.data,
      };
      break;

    case GetAllCompletedChatSessionsActionConst.GET_ALL_COMPLETED_CHAT_SUCC:
      state = {
        ...state,
        allCompletedChatSessions: [],
        selectedCompletedSessionId: null,
      };
      break;

    case selectedSessionIdActionConsy.SELECTED_CHAT_ID:
      state = {
        ...state,
        selectedSessionId: action.id,
      };
      break;

    case selectedSessionIdActionConsy.SELECTED_CHAT_ID:
      state = {
        ...state,
        selectedCompletedSessionId: action.id,
        selectedSessionId: null,
      };
      break;

    case GetCurrentShiftActionConst.GET_CURRENT_SHIFT_SUCC:
      state = {
        ...state,
        currentShift: action.data,
      };
      break;

    case ShiftCheckOutHandlerConst.SHIFT_CHECKOUT:
      state = {
        ...state,
        allActiveChatSessions: [],
        selectedSessionId: null,
        currentShift: null,
      };
      break;

    case SelectedSessionIdActionConst.SELECTED_SESSION_ID:
      state = {
        ...state,
        sessionIdPastShift: action.id,
      };
      break;

    case selectedCompletedSessionIdActionConsy.SELECTED_COMPLETED_CHAT_ID:
      state = {
        ...state,
        selectedCompletedSessionId: action.id,
      };
      break;
    case GetAllActiveChatsActionConst.UPDATE_ACTIVE_CHAT_SESSION:
      console.log("🔄 Updating active chat session...", action.data);

      // Handle case where we have a single message object instead of a session
      if (action.data.messageObj && action.data.sessionId) {
        const sessionIndex = state.allActiveChatSessions.findIndex(
          (session) => session._id === action.data.sessionId
        );

        if (sessionIndex !== -1) {
          const updatedSessions = [...state.allActiveChatSessions];
          updatedSessions[sessionIndex] = {
            ...updatedSessions[sessionIndex],
            conversation: [
              ...updatedSessions[sessionIndex].conversation,
              action.data.messageObj,
            ],
          };

          return {
            ...state,
            allActiveChatSessions: updatedSessions,
          };
        }
      }

      // Handle case where we have a complete session object
      if (action.data._id) {
        const existingSessionIndex = state.allActiveChatSessions.findIndex(
          (session) => session._id === action.data._id
        );

        if (existingSessionIndex !== -1) {
          console.log("✅ Updating existing session", existingSessionIndex);
          const updatedSessions = [...state.allActiveChatSessions];
          updatedSessions[existingSessionIndex] = {
            ...updatedSessions[existingSessionIndex],
            ...action.data,
            conversation:
              action.data.conversation ||
              updatedSessions[existingSessionIndex].conversation,
          };

          return {
            ...state,
            allActiveChatSessions: updatedSessions,
          };
        } else {
          console.log("➕ Adding new session from socket...");
          return {
            ...state,
            allActiveChatSessions: [
              action.data,
              ...state.allActiveChatSessions,
            ],
          };
        }
      }

      // Handle case where we have a single message object (from socket)
      if (action.data.id && action.data.message && !action.data._id) {
        console.log("📨 Processing single message from socket...");

        // Find the session that this message belongs to
        // Look for sessions that have recent messages from this user
        const sessionIndex = state.allActiveChatSessions.findIndex(
          (session) => {
            // Check if any recent messages in the conversation are from this user
            const recentMessages = session.conversation.slice(-5); // Check last 5 messages
            return recentMessages.some((msg) => msg.id === action.data.id);
          }
        );

        if (sessionIndex !== -1) {
          console.log("✅ Found session for message, updating...");
          const updatedSessions = [...state.allActiveChatSessions];

          // Check if this message already exists to avoid duplicates
          const messageExists = updatedSessions[sessionIndex].conversation.some(
            (msg) =>
              msg.dateTime === action.data.dateTime &&
              msg.message === action.data.message
          );

          if (!messageExists) {
            updatedSessions[sessionIndex] = {
              ...updatedSessions[sessionIndex],
              conversation: [
                ...updatedSessions[sessionIndex].conversation,
                action.data,
              ],
            };

            return {
              ...state,
              allActiveChatSessions: updatedSessions,
            };
          } else {
            console.log("⚠️ Message already exists, skipping...");
          }
        } else {
          console.log("⚠️ Could not find session for message");
        }
      }

      return state;
  }
  console.log("existingSessionupdatedSessionsstate", state);

  return state;
};
